'Morsel'.datatype()
'morsel_type'.field()
'order_item_id'.field()
'product_id'.field()
'quantity'.field({numeric: true})
'amount'.field({numeric: true})
'morsel_date'.field() // NOTE: includes time
'user_login'.field()
